import {Request} from '../../utils/request';
import User from '../../api/user'
const state = ()=>({
	isShowSearch: false,//是否显示搜索组件
	isShowVideoBtn:true,//是否显示首页播放相关框架按钮
	headerHideAble:false,//是否可隐藏公共头部，当设置为true时，可以在指定情况下状态伸缩，当前用于首页播放页面时隐藏头部

	//热门搜索数据
	searchHot:['中心监管平台系统', '有线数字监测', '前端监测主机', 'CPCI刀片式广播电视监测主控板', '地面数字电视信号监测卡'],

	//产品列表
	productList: {
		//硬件
		hardware:[
			{
				id:1,
				name:'前端监测主机',
				code:'DAVS-JCBOX',
				img:'/static/img/product/hardware_01.png',
				describe:`1.19英寸标准工业级机架式机箱%2.支持标准CPCI设备%3.支持热插拔%4.冗余双电源%5.支持远程电源管理%6.内部具备散热模组&7.满足业务的分发和数据的存储%8.硬盘容量≥16TB%9.缓存≥256MB%10.转速≥7200rpm%11.接口速率≥6Gb/秒%12.平均无故障时间≥10万小时。`,
				summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
			},
			{
				id:2,
				name:'DAVS-Multy数字模拟信号回传服务器',
				code:'DAVS-Multy',
				img:'/static/img/product/hardware_02.png',
				describe:`实现数字模拟节目灵活的选择性回传显示监测报警，支持实时及轮循显示监测。用户在一个操作接口上实现对任意信号类型节目的监测，达到模拟和数字监测的无缝透明融合。满足下县节目进行选择性分割、监测、分析、报警、录制的后续扩展需求。用户可以灵活配置到“某时刻（时分秒）、某监测项、怎样的错误处理动作/监测阈值”等粒度。`,
				summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
			},
      {
        id:3,
        name:'嵌入式多画面监测设备',
        img:'/static/img/product/hardware_03.png',
        describe:`1)19英寸工业级机架式机箱；
        2)前后机箱加嵌入式业务监测卡，支持≥4个槽位，支持板卡热插拔；
        3)支持≥6个数据输入网口、2个数据输出网口、1个管理网口，支持数据输入/数据输出/管理口物理分离；
        4)支持≥6路HDMI输出、3路VGA输出和3路模拟音频输出；
        5)支持UDP、RTSP、RTMP、HLS和HTTP等输入；
        6)支持≥12路4K/60路高清/144路标清信号解码；
        7)支持主流的视频格式：AVS2、H.265、H.264、MPEG2、MPEG4、AVS、AVS+等；
        8)支持主流的音频格式：MPEG、AAC、AC3、DRA 等；
        9)支持音视频转码，视频H.265/H.264格式，音频AAC 格式，转码参数可自定义，TS OVER UDP 输出；
        10)支持静帧、彩条、黑场、彩场、音频无伴音等异态报警；
        11)支持节目名称、音量柱等OSD叠加功能；
        12)支持拼接画面IP 输出，编码格式为H.264，输出格式为UDP或RTSP。`,
      summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
    },
    {
        id:4,
        name:'CPCI刀片式广播电视监测主控板',
        img:'/static/img/product/hardware_01.png',
        describe:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`,
      summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
    },
    {
        id:5,
        name:'地面数字电视信号监测卡',
        img:'/static/img/product/hardware_02.png',
        describe:`1.19英寸标准工业级机…<br>\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`,
      summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
    },

		],
		//软件
		// software:[
		// 	{
		// 		id:1,
		// 		name:'地面数字电视信号监测-显示模块',
		// 		img:'/static/img/product/software_01.png',
		// 		describe:`通过数据处理中心软件，以语言、文字、图形的手段灵活显示，例如显示监测网拓扑结构、监测前端地理分布电子地图、异态报警信息、节目波形、测量结果以及频道频谱扫描图等。`,
		// 		summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
		// 	},
		// 	{
		// 		id:2,
		// 		name:'地面数字电视信号监测-EPG信息模块',
		// 		img:'/static/img/product/software_01.png',
		// 		describe:`通过数据处理中心软件，以语言、文字、图形的手段灵活显示，例如显示监测网拓扑结构、监测前端地理分布电子地图、异态报警信息、节目波形、测量结果以及频道频谱扫描图等。`,
		// 		summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
		// 	},
    //   {
    //       id:3,
    //       name:'中心监管平台系统',
    //       img:'/static/img/product/software_01.png',
    //       describe:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`,
    //     summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
    //   },
    //   {
    //       id:4,
    //       name:'有线数字监测',
    //       img:'/static/img/product/software_01.png',
    //       describe:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`,
    //     summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
    //   },
		// ],
		//IPTV列表
    iptv:[
			{
				id:1,
				name:'IPTV监管系统简介',
				img:'/static/img/product/iptv_01.png',
				describe:`IPTV监管系统，充分应用人工智能、边缘计算等高新技术，包含省监测中心监管平台、集成播控平台（二级）采集监测前端、传输分发平台（三级）采集监测前端、用户终端（六级）采集监测前端，可完成直播节目播出异态监测、点播节目信息监测、终端EPG/APP 监测、节目一致性监测、节目频道监测、违规节目信息监测等核心功能业务系统，为省级IPTV 监测监管业务提供有力支撑，全面提升IPTV 智能化监测监管能力和水平。\r\n
        （一）直播节目安全播出异态监测
        实现多维度（含频道音视频层、码流层）一对一技术监测，对节目音视频马赛克、图像静止、视频断流、无视频、无音频、视频解码异常、彩场、彩条等异态进行监测。
        （二）点播节目信息监测
        实现对节目相关播放许可证信息进行监测，对涉及无许可证、无龙标、劣迹艺人等点播节目异常数据自动报警；系统具备对点播节目中违规境外剧自动发现并提交人工审核；支持对不同终端点播节目进行多画面监看。
        （三）EPG/APP 监测
        实现对用户端数据快速扫描、采集、定位，迅速识别终端内新增、变化数据。自动触发对终端的开机画面、境外剧识别、APP 识别、应用关键字异常、公网监测异常等监测功能。
        对新增、下线节目进行识别上报，对私增频道等异常情况进行报警上报。
        （四）节目一致性监测
        实现对集成播控分平台、传输分发平台和用户端等各环节目内容的一致性监测比对，针对插播、错播和漏播等异态可实时报警。
        （五）违规节目信息监测
        实现对所有直播、点播、回看节目信息的采集，通过违规关键字匹配，宣传图片监测，版权识别、内容比对等技术手段自动识别违规节目。
        （六）人工智能检测引擎
        完成对IPTV 节目内容是否存在违规、敏感内容的自动研判提供依据。
        （七）数据分析及可视化
        为用户提供各种直观、内容丰富的报表。同时系统支持将监测结果数据转换成图表进行可视化展示、分析，实现业务数据的高效关联分析。
        （八）系统配置管理
        针对整套IPTV 监管平台，提供监测前端、采集任务、监测任务、报警参数、用户账户等层面的管理功能。
        （九）中心平台基础硬件支撑
        完成中心监管平台各功能建设所需的各类承载设备，包括多画面监看设备、业务承载服务器、GPU 服务器、交换机、操作终端等。
        （十）采集监测前端
        完成省级集成播控平台（二级）、传输分发平台（三级）、用户终端（六级）IPTV 节目及信息采集监测各功能所需的采集监测前端设备。`,
				summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
			},
			{
				id:2,
				name:'直播节目播出异态监测',
				img:'/static/img/product/iptv_02.png',
				describe:`实现直播节目播出异态监测，完成集成播控平台（二级）、传输分发平台（三级）、用户终端（六级）数据的汇总、整合与分析。
        1、播出质量管理
        实现直播高标清节目的质量监测，监测内容包括音视频、码流、音视频编码格式等运行数据和传输指标；
        2、直播节目内容采集回传监看
        提供节目监看功能，对直播节目进行多画面、多用户实时监看；可根据监看请求数量合理调度可用硬件资源，保证多个监看人员同时进行流畅的监看工作。支持频道搜索功能。
        3、直播节目采集收录
        中心监管平台支持对各级监测前端采集的节目数据进行汇总、解析和处理。建立统一的IPTV 节目编目存储，自动均衡存储空间，形成IPTV 节目信息库。`,
				summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
			},
      {
        id:3,
        name:'点播节目信息监测',
        img:'/static/img/product/iptv_03.png',
        describe:`实现点播节目信息监测，完成集成播控平台（二级）、传输分发平台（三级）、用户终端（六级）数据的汇总、整合与分析。
        1、许可证信息监测
        支持对集成播控平台、传输分发平台、用户终端的点播节目许可证信息的集中存储和管理，同时针对违规点播节目提供人工审核界面功能。
        2、点播节目内容采集回传监看
        对各级采集监测前端回传的点播节目码流接收、汇总和整合，实现多源、多画面、多用户实时监看；支持频道搜索功能。
        3、点播节目内容采集收录
        中心监管平台支持通过回看节目单或时间段等方式完成对任意各级采集监测前端指定时段点播节目录像的调阅查看。`,
        summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
      },
      {
        id:4,
        name:'EPG/APP 及节目频道监测',
        img:'/static/img/product/iptv_04.png',
        describe:`实现EPG/APP 信息监测，完成集成播控平台（二级）、传输分发平台（三级）、用户终端（六级）数据的汇总、整合与分析。
        1、EPG 信息监管
        中心监管平台支持对各级采集监测前端采集回传的EPG 信息进行统一汇总、整合，形成IPTV EPG 信息库，实现统一管理；
        支持对各级采集回传的EPG 信息进行差异比对，发现非法插播频道或节目；
        支持对EPG 核查中发现的违规节目进行自动报警。
        支持多维度搜索EPG信息数据，可按照直播、点播、回看栏目分类查看需要查看的EPG 内容，播放该EPG信息展示的节目内容，对疑似违规违法节目内容进行录像、截图取证，将相应取证材料提交给管理员进行审核。`,
        summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
      },
      {
        id:5,
        name:'节目一致性监测',
        img:'/static/img/product/iptv_9.png',
        describe:`实现节目一致性监测完成集成播控平台（二级）、传输分发平台（三级）、用户终端（六级）数据的汇总、整合与分析。
        1、一致性监测核查
        中心监管平台自动完成对各级采集的节目内容进行一致性比对监测，支持对截播、插播、错播和漏播时自动识别报警。`,
        summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
      },
      {
        id:6,
        name:'违规节目信息监测',
        img:'/static/img/product/iptv_05.png',
        describe:`实现违规节目信息监测，完成集成播控平台（二级）、传输分发平台（三级）、用户终端（六级）数据的汇总、整合与分析。
        1、IPTV 敏感信息库
        2、中心监管平台建立IPTV 敏感信息库，支持对淫秽色情、侵权盗版、非法台标、媒体报道禁用词等各类敏感节目信息的统一归档存储。`,
        summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
      },
      {
        id:7,
        name:'人工智能监测引擎',
        img:'/static/img/product/iptv_08.png',
        describe:`针对监测前端采集到的点播节目进行内容智能分析，构建违规样本库，完成对IPTV 节目内容是否存在违规、敏感内容的自动研判提供依据。系统运用人工智能技术，识别分析淫秽色情、低俗暴恐等违规有害节目，系统自动接收并实时显示报警信息，可对相关违规有害节目内容进行查询播放。`,
        summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
      },
      {
        id:8,
        name:'数据分析及可视化',
        img:'/static/img/product/iptv_06.png',
        describe:`支持对IPTV节目信息和违规信息进行分析统计，自动生成监管报告，为用户提供各种直观、内容丰富的报表，为了解全面情况、实施宏观管理等提供足够的支持；
        支持生成多种类型报表：包括节目频道安全播出统计、节目内容播出质量统计、节目频道变动统计、新增频道统计、点播节目上下线统计、违规形态统计、敏感信息统计等；
        支持对各监测前端及整个IPTV 运行总体情况进行汇总分析；
        支持可视化技术，进行多维度呈现，实现监测监管数据的关联分析和全景可视化；`,
        summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
      },
      {
        id:9,
        name:'系统配置管理',
        img:'/static/img/product/iptv_07.png',
        describe:`1、业务配置管理
        监测前端管理：支持对各监测前端的增删改查等业务操作，包括前端名称、通讯地址/端口、编号、地域、经纬度等信息的修改，同时能展示前端的板卡配置情况；
        采集任务管理：支持对各级监测前端直播频道采集任务、点播EPG 采集任务、回看EPG 采集任务的统一调度；
        2、用户账户管理
        支持各平台各级各类操作用户进行一站式的用户账号管理，形成集中的用户信息库，作为整个业务系统的基础数据；
        支持对系统的用户角色进行合理分配，按照不同的功能职责内置相应的角色，并和操作权限绑定；
        支持将系统的用户和监测前端进行绑定，针对不同用户设置不同的监测前端访问权限。
        3、专项任务管理
        支持在重要时期，自定义任务模板，包括设定完成：错播监测、人脸识别等功能。监管人员根据业务监测的具体需求自定义多个任务调度模板，系统支持模板之间的互相切换。
        3、机顶盒画面采集、录制、回传
        4、支持在中心监管平台实现对IPTV 机顶盒的模拟操作，并实时回传实际播出节目内容；
        支持控制机顶盒模拟用户操作的功能，完成直播节目、回看节目、点播节目、其它资讯类节目的收看等功能；
        支持对机顶盒输出画面的实时录制。`,
        summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
      },
      {
        id:11,
        name:'采集监测前端',
        img:'/static/img/product/iptv_comm.png',
        describe:`采集监测前端包括集成播控平台（二级）采集监测前端、传输分发平台（三级）采集监测前端、用户终端（六级）采集监测前端，各级采集监测前端采用广播电视监测专用设备，嵌入式架构，支持多类型信号的接入。
        为降低中心平台的业务负荷，各级采集监测充分考虑边缘计算，充分利用各级采集监测前端分配监测处理能力。`,
        summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
      },
      {
        id:12,
        name:'集成播控平台（二级）采集监测前端',
        img:'/static/img/product/iptv_comm.png',
        describe:`对集成播控平台节目信号和EPG/APP数据信息进行采集，集成播控平台（二级）采集前端具备不少于350 套直播节目、240 小时每日点播节目的采集、监测与收录能力，录制时长不低于30 天。
        集成播控平台（二级）采集监测前端充分考虑边缘计算，充分利用各级采集监测前端分配监测处理能力。
        （一）直播节目播出异态监测
        实现直播节目播出异态监测，完成集成播控平台（二级）、传输分发平台（三级）、用户终端（六级）数据的汇总、整合与分析。
        1、播出质量管理
        支持对不少于350 套直播高标清节目进行多维度（含频道音视频层、码流层）一对一技术监测；
        支持对节目音视频马赛克、图像静止、视频断流、无视频、无音频、视频解码异常、彩场、彩条等异态进行监测；
        故障报警信息支持实时回传至中心监管平台。
        2、直播节目内容采集回传监看
        支持将集成播控平台（二级）的直播视频流进行回传，可根据用户需求与系统的实际运行状况，选择相应频道进行回传，满足中心监管平台的调阅监看。
        3、直播节目采集收录
        支持对不少于350 套直播高标清节目的转码、录像；
        录像视频格式支持H.264，音频格式支持AAC，分辨率及码率支持自定义设置；
        录像文件存储不少于30 天。
        （二）点播节目信息监测
        实现点播节目信息监测，完成集成播控平台（二级）、传输分发平台（三级）、用户终端（六级）数据的汇总、整合与分析。
        1、许可证信息监测
        支持对集成播控平台（二级）的IPTV 点播节目（含节目内容、节目信息）相关播放许可证信息进行监测，支持对无许可证、龙标、劣迹艺人等点播节目异常数据自动报警；
        支持对点播节目违规境外剧发现、报警及回传至中心监管平台用于人工审核。
        2、点播节目内容采集回传监看
        支持将集成播控平台（二级）的点播视频流进行回传，采集监测前端提供灵活的点播视频回传任务，可根据用户需求与系统的实际运行状况，选择相应节目进行回传，满足中心监管平台的调阅监看。
        3、点播节目内容采集收录
        支持对不少于240小时点播节目的转码、录像；
        录像视频格式支持H.264，音频格式支持AAC，分辨率及码率支持自定义设置；
        录像文件存储不少于30 天。
        （三）EPG/APP 及节目频道监测
        实现EPG/APP 信息监测，完成集成播控平台（二级）、传输分发平台（三级）、用户终端（六级）数据的汇总、整合与分析。
        1、EPG/APP 信息采集回传
        支持根据设定的计划任务定时进行EPG/APP 数据采集（包括直播节目表、点播节目表）或实时接收集成播控平台推送的EPG/APP 信息，上报中心监管平台；
        支持获取的EPG 信息包括：节目名称、海报、内容简介、主演、导演、节目、上线时间、节目时长、节目地址等信息；
        支持获取的APP 信息包括：APP 名称、发布主体、发布时间、描述、版本等信息；
        支持与平台下发的EPG 信息进行自动比对核查，实现EPG 信息的防篡改监测，主动发现隐藏频道、私自增设的频道。
        （四）节目一致性监测
        实现节目一致性监测，完成集成播控平台（二级）、传输分发平台（三级）、用户终端（六级）数据的汇总、整合与分析。
        1、节目内容特征值提取
        支持采集直播节目内容的特征值信息，实时存储到数据库中；
        支持与平台下发的节目特征值信息自动比对；
        支持节目内容的插转播监测。
        （五）违规节目信息监测
        实现违规节目信息监测，完成集成播控平台（二级）、传输分发平台（三级）、用户终端（六级）数据的汇总、整合与分析。
        1、图像语音智能AI 鉴别、监测报警
        支持对视频帧中的图像、字幕进行审核，实现对直播和点播节目内容中出现的低俗色情内容，血腥、暴力、恐怖内容，台标等内容进行全面审核；
        支持根据色情审核模型，针对健身、艺术品等正常较裸露场景，保持更高精度识别；
        支持根据暴恐审核模型，精准识别图像中是否包含杀人流血场景、暴恐袭击场景、恐怖分子头目照片、恐怖组织的旗帜、暴力行为等内容；
        支持根据人脸识别模型，精准识别图像中的目标人物，最小识别人脸尺寸不高于80px*80px。`,
        summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
      },
      {
        id:13,
        name:'传输分发平台（三级）采集监测前端',
        img:'/static/img/product/iptv_comm.png',
        describe:`传输分发平台（三级）采集监测前端对移动、联通、电信三个运营商传输分发平台节目信号和EPG/APP 数据信息进行采集，传输分发平台（三级）采集前端针对每个运营商具备不少于350 套直播节目、240 小时每日点播节目的采集、监测与收录能力，录制时长不低于30 天。
        传输分发平台（三级）采集监测前端充分考虑边缘计算，充分利用各级采集监测前端分配监测处理能力。
        （一）直播节目播出异态监测
        实现直播节目播出异态监测，完成集成播控平台（二级）、传输分发平台（三级）、用户终端（六级）数据的汇总、整合与分析。
        1、播出质量管理
        支持对不少于350 套直播高标清节目进行多维度（含频道音视频层、码流层）一对一技术监测；
        支持对节目音视频马赛克、图像静止、视频断流、无视频、无音频、视频解码异常、彩场、彩条等异态进行监测；
        故障报警信息支持实时回传至中心监管平台。
        2、直播节目内容采集回传监看
        支持将传输分发平台（三级）的直播视频流进行回传，可根据用户需求与系统的实际运行状况，选择相应频道进行回传，满足中心监管平台的调阅监看。
        3、直播节目采集收录
        支持对每个运营商不少于350 套直播高标清节目的转码、录像；
        录像视频格式支持H.264，音频格式支持AAC，分辨率及码率支持自定义设置；
        录像文件存储不少于30 天。
        （二）点播节目信息监测
        实现点播节目信息监测，完成集成播控平台（二级）、传输分发平台（三级）、用户终端（六级）数据的汇总、整合与分析。
        1、许可证信息监测
        支持对传输分发平台（三级）的IPTV 点播节目（含节目内容、节目信息）相关播放许可证信息进行监测，支持对无许可证、龙标、劣迹艺人等点播节目异常数据自动报警；
        支持对点播节目违规境外剧发现、报警及回传至中心监管平台用于人工审核。
        2、点播节目内容采集回传监看
        支持将传输分发平台（三级）的点播视频流进行回传，采集监测前端提供灵活的直播视频回传任务，可根据用户需求与系统的实际运行状况，选择相应节目进行回传，满足中心监管平台的调阅监看。
        3、点播节目内容采集收录
        支持对每个运营商不少于240 小时点播节目的转码、录像；
        录像视频格式支持H.264，音频格式支持AAC，分辨率及码率支持自定义设置；
        录像文件存储不少于30 天。
        （三）EPG/APP 及节目频道监测
        实现EPG/APP 信息监测，完成集成播控平台（二级）、传输分发平台（三级）、用户终端（六级）数据的汇总、整合与分析。
        1、EPG/APP 信息采集回传
        支持根据设定的计划任务定时进行EPG/APP 数据采集（包括直播节目表、点播节目表）或实时接收传输分发平台推送的EPG/APP 信息，上报中心监管平台；
        支持获取的EPG 信息包括：节目名称、海报、内容简介、主演、导演、节目、上线时间、节目时长、节目地址等信息；
        支持获取的APP 信息包括：APP 名称、发布主体、发布时间、描述、版本等信息；
        支持与平台下发的EPG 信息进行自动比对核查，实现EPG 信息的防篡改监测，主动发现隐藏频道、私自增设的频道。
        （四）节目一致性监测
        实现节目一致性监测，完成集成播控平台（二级）、传输分发平台（三级）、用户终端（六级）数据的汇总、整合与分析。
        1、节目内容特征值提取
        支持采集直播节目内容的特征值信息，实时存储到数据库中；
        支持与平台下发的节目特征值信息自动比对；
        支持节目内容的插转播监测。
        （五）违规节目信息监测
        实现违规节目信息监测，完成集成播控平台（二级）、传输分发平台（三级）、用户终端（六级）数据的汇总、整合与分析。
        1、图像语音智能AI 鉴别、监测报警
        支持对视频帧中的图像、字幕进行审核，实现对直播和点播节目内容中出现的低俗色情内容，血腥、暴力、恐怖内容，台标等内容进行全面审核；
        支持根据色情审核模型，针对健身、艺术品等正常较裸露场景，保持更高精度识别；
        支持根据暴恐审核模型，精准识别图像中是否包含杀人流血场景、暴恐袭击场景、恐怖分子头目照片、恐怖组织的旗帜、暴力行为等内容；
        支持根据人脸识别模型，精准识别图像中的目标人物，最小识别人脸尺寸不高于80px*80px。`,
        summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
      },
      {
        id:14,
        name:'用户终端（六级）采集监测前端',
        img:'/static/img/product/iptv_comm.png',
        describe:`用户终端（六级）采集监测前端对用户市县级移动、联通、电信三个运营商用户终端节目信号和EPG/APP 数据信息进行采集，用户终端（六级）采集监测前端针对每个运营商具备不少于300套直播节目、240小时每日点播节目的采集、监测与收录能力，录制时长不低于30 天。
        用户终端（六级）采集监测前端充分考虑边缘计算，充分利用各级采集监测前端分配监测处理能力。
        （一）直播节目播出异态监测
        实现直播节目播出异态监测，完成集成播控平台（二级）、传输分发平台（三级）、用户终端（六级）数据的汇总、整合与分析。
        1、播出质量管理
        支持对每个运营商不少于350套直播高标清节目进行多维度（含频道音视频层、码流层）一对一技术监测；
        支持对节目音视频马赛克、图像静止、视频断流、无视频、无音频、视频解码异常、彩场、彩条等异态进行监测；
        故障报警信息支持实时回传至中心监管平台。
        2、直播节目内容采集回传监看
        支持将用户终端（六级）的直播视频流进行回传，可根据用户需求与系统的实际运行状况，选择相应频道进行回传，满足中心监管平台的调阅监看。
        3、直播节目采集收录
        支持对每个运营商不少于350 套直播高标清节目的转码、录像；
        录像视频格式支持H.264，音频格式支持AAC，分辨率及码率支持自定义设置；
        录像文件存储不少于30 天。
        （二）点播节目信息监测
        实现点播节目信息监测，完成集成播控平台（二级）、传输分发平台（三级）、用户终端（六级）数据的汇总、整合与分析。
        1、许可证信息监测
        支持对用户终端（六级）的IPTV 点播节目（含节目内容、节目信息）相关播放许可证信息进行监测，支持对无许可证、龙标、劣迹艺人等点播节目异常数据自动报警；
        支持对点播节目违规境外剧发现、报警及回传至中心监管平台用于人工审核。
        2、点播节目内容采集回传监看
        支持将用户终端（六级）的点播视频流进行回传，采集监测前端提供灵活的直播视频回传任务，可根据用户需求与系统的实际运行状况，选择相应节目进行回传，满足中心监管平台的调阅监看。
        3、点播节目内容采集收录
        支持对每个运营商不少于240小时点播节目的转码、录像；
        录像视频格式支持H.264，音频格式支持AAC，分辨率及码率支持自定义设置；
        录像文件存储不少于30 天。
        （三）EPG/APP 及节目频道监测
        实现EPG/APP 信息监测，完成集成播控平台（二级）、传输分发平台（三级）、用户终端（六级）数据的汇总、整合与分析。
        1、EPG/APP 信息采集回传
        支持自动对用户端数据快速扫描、采集、定位，迅速识别终端内新增、变化数据；
        支持自动触发对终端的开机画面、境外剧识别、APP 识别、应用关键字异常、公网监测异常；
        支持自动将问题数据推送到中心监管平台进行数据分析、核查和管理；
        支持获取的EPG 信息包括：节目名称、海报、内容简介、主演、导演、节目、上线时间、节目时长、节目地址等信息；
        支持获取的APP 信息包括：APP 名称、发布主体、发布时间、描述、版本等信息；
        支持与平台下发的EPG 信息进行自动比对核查，实现EPG 信息的防篡改监测，主动发现隐藏频道、私自增设的频道。
        （四）节目一致性监测
        实现节目一致性监测，完成集成播控平台（二级）、传输分发平台（三级）、用户终端（六级）数据的汇总、整合与分析。
        1、节目内容特征值提取
        支持采集直播节目内容的特征值信息，实时存储到数据库中；
        支持与平台下发的节目特征值信息自动比对；
        支持节目内容的插转播监测。
        （五）违规节目信息监测
        实现违规节目信息监测，完成集成播控平台（二级）、传输分发平台（三级）、用户终端（六级）数据的汇总、整合与分析。
        1、图像语音智能AI 鉴别、监测报警
        支持对视频帧中的图像、字幕进行审核，实现对直播和点播节目内容中出现的低俗色情内容，血腥、暴力、恐怖内容，台标等内容进行全面审核；
        支持根据色情审核模型，针对健身、艺术品等正常较裸露场景，保持更高精度识别；
        支持根据暴恐审核模型，精准识别图像中是否包含杀人流血场景、暴恐袭击场景、恐怖分子头目照片、恐怖组织的旗帜、暴力行为等内容；
        支持根据人脸识别模型，精准识别图像中的目标人物，最小识别人脸尺寸不高于80px*80px。`,
        summary:`1.19英寸标准工业级机…\n\r2.支持标准CPCI设备\n\r3.支持热插拔\n\r……\n\r`
      },
		],

    //2023.09.05================================================新版官网产品中心
    //2023.09.05================================================
    //2023.09.05================================================
    //2023.09.05================================================
    //有线数字电视监测前端系统
		szdsqd:[
      {
				id:1,
				name:'有线数字电视监测前端系统',
				img:'',
				describe:`有线数字电视监测前端系统，型号:DAVS-DTV。
        有线数字电视监测前端系统通过现有专用通信网络方式联网，接入中心监测系统。实时接收中心系统下达的指令并执行监测任务，主要完成有线数字电视的接收及解扰、指标测量、监测报警、视音频编码或转码、监测数据、录像存储、远程管理等任务。`,
				summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
			},
      {
				id:1,
				name:'监测前端系统软件',
				img:'',
				describe:`有线数字电视监测前端系统，能实时接收中心监测系统的监测任务指令；能对有线电视前端播出的DVB-C和IP组播信号进行采集，并对主要技术指标进行测量和越限报警；能存储测量指标、越限及异态报警等监测数据和节目录像；能向监测平台上传监测数据和节目录像，接口符合《有线数字广播电视监管采集设备入网技术要求及测量方法》(GD/J010)要求。`,
				summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
			},
			{
				id:2,
				name:'监测前端基本功能',
        img:'',
				describe:`1、实时接收监测平台的监测任务指令；
        2、对有线电视前端播出信号进行采集，并对主要技术指标进行测量和越限报警；
        3、存储测量指标、越限及异态报警等监测数据和节目录像；
        4、向监测平台上传监测数据和节目录像；
        5、当监测前端与监测平台的网络连接中断后恢复时，监测前端能主动恢复与监测平台的通信，并将连接中断期间存储的监测数据和节目录像上传监测平台；
        6、单个前端可完成32个频点DVB-C信号和128个IP组播地址节目的高、标清节目一对一录像监测；`,
				summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
			},
      {
          id:3,
          name:'有线电视接收功能',
          img:'',
          describe:`1、能采集有线电视分前端播出的数字电视节目和数据；
          2、能采集电子节目单(EPG)，对有线数字电视节目不同频道和时间的EPG信息查看；(EPG扫描功能)
          3、能扫描指定频率范围内的数字电视频道，对新增频道和减少频道情况进行报警，并可对任意选定节目进行实时选择播放；(频道扫描及实时播放功能)
          4、支持CAM卡进行授权节目解扰，单CAM卡≥8路节目的解扰。`,
        summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
      },
      {
          id:4,
          name:'指标测量及越限监测报警功能',
          img:'',
          describe:`1、能测量有线电视前端输出的QAM调制信号的信号功率、MER和BER，并绘制星座图；
          2、信号功率的测量范围为50dBµV~80dBµV，测量误差≤±3dBuV；
          3、MER的测量范围达到24dB~32dB，测量误差≤±1dB；
          4、BER的测量达到38Mbps码流测量1min，测量误差≤10-7；
          5、能向监测平台发送信号功率、MER和BER等指标的越限报警信息；
          6、TS码流的标准符合性测量，支持TR101 290规范定义的一级、二级、三级指标进行监测和报警；
          （1）第一级监测指标：同步丢失错误、同步字节错误、PAT错误、连续计数错误、PMT错误、PID错误；
          （2）第二级监测指标：传输错误、CRC错误、PCR间隔错误、PCR抖动错误、PTS错误、CAT错误。
          （3）第三级监测指标：反映MPEG-2传输流中的数据表格（SI表格）有错误，如表格序号错误或者表格数据的间隔和重复率不符合要求或者表格数据不完整等（这些表格包括SDT、EIT、RST、TDT等）。
          7、能向监测平台发送TS码流的标准符合性错误报警信息。
          8、TS流的基本结构信息监测：能实现TS流的基本结构信息监测，包括TS流的信息构成、TS包的包长、PSI/SI表的传输间隔、传输流的ID、PID的数量、网络ID和网络名称。
          9、码流带宽实时监测：能实现码流带宽分析功能，包括整个TS流总码率的最小值、最大值、有效值、当前值、TS流中每路节目的码率和所占带宽的比率、PSI/SI中每个PES的码率、空包率和其它数据的码率。`,
        summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
      },
      {
        id:5,
        name:'视音频解码功能',
        img:'',
        describe:`1、支持视频编码格式包括但不限于MPEG-2、H.264、H.265、AVS2、AVS3等；
        2、支持音频编码格式包括但不限于MP3、AC3、AAC等。`,
        summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
      },
      {
        id:6,
        name:'视音频异态监测及报警功能',
        img:'',
        describe:`1、能对静帧、彩条、彩场、黑场、无音频、无视频等异态进行监测；
        2、能向监测平台发送视音频异态报警信息。
        无音频：1-600秒可调，可按频道、时间段任意设置；
        彩条：1秒，报警延时时间可调（1-60秒）；
        黑场： 1-10秒可调，可按频道、时间段任意设置；
        静止画面：1-600秒可调，可按频道、时间段任意设置；
        3、报警联动功能，各监测前端出现报警情况，中心可同时报警。事故记录在当地存储，同时上传到监测中心实时存储。`,
        summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
      },
      {
        id:7,
        name:'视音频编码或转码功能',
        img:'',
        describe:`1、编码或转码采用硬件方式实现，支持MPEG-2、H.264、H.265、AVS2、AVS3等视频编码格式，编码保持原帧率，编码码率宜在200kbps~8000kbps 之间可配置；能将编码节目上传到监测平台；
        2、视频编码输出分辨率支持1080P、720P、720×576(PAL)、760×480(NTSC)，帧率：25F/S；视频编码码率200kbps~8000kbps可调，音频码率16kbps-128kbps可调；
        3、支持在输出的视频画面上叠加OSD信息。OSD信息可以由用户自行调整，包含对齐方式、字体大小、OSD位置、信息内容等。`,
        summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
      },
      {
        id:8,
        name:'监测数据及节目录像存储功能',
        img:'',
        describe:`1、能存储监测指标数据、报警数据及节目录像等；
        2、监测数据存储一个月以上，异态节目数据存储一年以上。支持录制参数可自定义配置，例如文件分片时长、文件分片大小、存储周期、硬盘保护最小空间等；
        3、监测前端设备支持提供录像文件和流媒体两种方式；
        4、录像文件的视频分辨率不低于640*480，帧率25帧/秒，音频采样率不低于16kHz；
        5、录像文件内部无跳帧、花屏、卡顿、抖动、噪声异常等异态现象；
        6、录像文件的时间戳(DTS、PTS)从0开始，支持播放器的拖放定位操作；
        7、录像数据为h264编码的mp4格式，支持media player或vlc播放器无需转码直接播放；
        8、单个录像文件时长不小于30分钟，不长于60分钟；
        9、相邻两个录像文件的时间间隔不能多于1秒；
        10、录像文件按频道、按年月日分级分目录存储，单个目录存储的录像文件不超过1000个；
        11、录像的文件名至少包含频道、录像起止时间等信息；
        12、流媒体传输方式，是由前端设备将数字电视信号解扰封装成清流IP信号输出，支持http标准协议；
        13、流媒体保持稳定可靠，中断时间不超过300毫秒，延迟不超过500毫秒。
        14、异态节目内容存储功能：能把“报警起始时间”超前10秒（可设置）至“报警结束时间”以后10秒（可设置）这段时间内的节目内容信息全部自动存储起来，供查询。`,
        summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
      },
      {
        id:9,
        name:'远程控制功能',
        img:'',
        describe:`1、能向监测平台上传监测设备及板卡运行状态、存储剩余空间、CPU利用率、温度及内存使用情况等信息；
        2、能远程自动和手动开关监测前端设备，支持系统软件远程升级功能。
        3、支持节目信息设置功能、监测报警参数设置功能、监测设备异常自动处理功能、电源保护功能、远程存储功能。`,
        summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
      },
      {
        id:10,
        name:'系统时钟同步功能',
        img:'',
        describe:`前端设备及板卡与中心系统的实时时钟同步，保证整网的时间一致性，累计误差≤1s/24h。`,
        summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
      },
      {
        id:11,
        name:'安全性监测',
        img:'',
        describe:`1、频道扫描：可实时或定时对所在地有线数字电视系统进行频道扫描；可在指定频率范围内准确锁定出频段内所有播出频率（频道），或者指定扫描频率范围、步长，或者指定中心频率、带宽，或者系统能够根据选定的频率范围自动选择合理的设置进行频道扫描。频道扫描结果须自动记录并上传到中心平台。
        2、发现新频点：监测前端的监测设备根据中心布置的任务要求，通过对规定的频段范围进行逐点扫描。对频点进行锁定、码流分析、扫描结果与前一天的扫描结果进行比对，或者与中心定义的频点列表进行比对，自动发现新频点，并上报中心。
        3、发现新节目：监测前端的监测设备根据中心布置的任务要求，核查频道扫描后的节目列表。对频点进行锁定、码流分析、PSI/SI分析，分析结果与前一天的结果进行比对，或者与中心定义的节目列表进行比对，自动发现新节目，并上报中心。`,
        summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
      },
      {
        id:12,
        name:'监测前端硬件基本性能',
        img:'',
        describe:`1、监测前端按无人值守的工作方式设计实现，设备所有部件满足7×24小时不间断工作；
        2、电磁兼容性：EMI符合EN55022/FCC B类，系统接地电阻≤4Ω；平均无故障工作时间(MTBF)≥10000h；
        3、电源适应性：交流(220×(1±10％)V、50×(1±5％)Hz)；
        4、系统适应工作环境：温度-10℃—+55℃、湿度≤85%、海拔高度≤5000m；
        5、设备具有高度集成性，尺寸符合标准机柜安装工艺尺寸；
        6、采集监测设备主要包含监测机箱、监测卡、转码卡、主控卡、CAM大卡。`,
        summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
      },
      {
        id:13,
        name:'监测机箱(含电源)',
        img:'/static/img/product/DAVS-JCBOX.png',
        describe:`监测机箱(含电源)，型号:DAVS-JCBOX。
        1、19英寸工业级机架式机箱，支持热插拔、冗余双电源。
        2、支持各类板卡功能模块的前、后装载，方便各功能板卡安装，信号等连接线在后装载的板卡实现，板卡工作状态显示采用板卡的前装载的板卡实现，便于安装，易维护。`,
        summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
      },
      {
        id:14,
        name:'监测卡',
        img:'/static/img/product/DAVS-DTV-JCK.png',
        describe:`监测卡，型号: DAVS-DTV/JCK。
        1、单块板卡支持4路QAM(包括QAM32、QAM64、QAM128、QAM256)信号解调，信道指标采集监测，支持热插拔；
        2、板卡支持监测的信道指标包括:射频信号锁定状态、信号电平、调制误差比(MER)、误码率(BER)、误差向量幅度(EVM)、载噪比(C/N)、比特信噪比(Eb/N0)、信号质量、频率偏移、符号率偏移等；
        3、支持码流PSI/SI表格的深度解析,支持EPG信息的解析；
        4、支持频率范围：47MHz-1004MHz；DVB-C信号接入采用75Ω F接口；
        5、误报率≤1%，漏报率≤1%；
        6、载波电平精度：±1dB；载噪比(C/N) 精度：±1dB；MER监测范围：20dB~40dB；BMER监测误差：±1dB；BER监测范围:10-9~1；误码率精度:10-9；信道失锁反应时间 1s。
        7、视音频响应时间≤2秒；
        8、支持Over IP传输，并支持PCI总线传输，提高系统可靠性。
        9、支持码流表格的深度解析,支持数据广播和EPG信息的解析。`,
        summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
      },
      {
        id:14,
        name:'转码卡',
        img:'/static/img/product/DAVS-DTV-ZMK.png',
        describe:`转码卡，型号: DAVS-DTV/ZMK。
        1、转码卡支持4K超高清、高清、标清信号的视音频异态监测及转码；
        2、板块支持Over IP传输，并支持PCI总线传输；支持热插拔,支持IPV4和IPV6协议；
        3、编码或转码采用硬件方式实现，转码后的视频分辨率、码率可根据中心平台指令调整；
        4、支持将输入的TS流进行解复用,选择部分或全部节目进行实时压缩转码及监测；
        5、输入视频格式支持MPEG2/H.264/H.265/AVS+/AVS2/AVS3等,输入音频格式支持MP2/AAC/AC3/DRA；输出视频格式支持H.264/H.265，输出音频格式支持AAC/MP3/AC3；
        6、视频编码输出分辨率支持1080P(1920×1080)、720P(1280×720、960×720)、960×540、720×576(PAL)、760×480(NTSC)，帧率：25F/S；视频编码码率200kbps~8000kbps可调，音频码率16kbps-128kbps可调；
        7、支持节目视音频的静帧、黑场、视频解码异常、视频丢失、音频丢失、音量过高过低、彩条、彩场等报警；
        8、支持输出画面亮度、对比度、饱和度、色调调节；
        9、支持在输出的视频画面上叠加OSD信息；
        10、支持手动校时和全网同步自动校时。
        11、支持查看转码源流输入状态、节目锁定状态、视音频类型、输入输出带宽实时查看；
        12、与前装载的“数字电视主控板”配合使用，实现前面显示转码板的工作状态，易维护；
        13、视音频响应时间≤2秒；`,
        summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
      },
      {
        id:15,
        name:'主控卡',
        img:'/static/img/product/DAVS-DTV-ZKK.png',
        describe:`主控卡，型号：DAVS-DTV/ZKK。
        主控卡用于完成对数字电视监测前端设备控制管理等功能。
        1、板卡支持Over IP传输，并支持PCI总线传输，支持热插拔,支持IPV4和IPV6协议；
        2、支持mSATA/SATA存储，可以自动保存参数配置，支持IP磁盘阵列读写，可配置独立IP磁盘阵列；
        3、支持有线数字电视信号的监测报警，支持各种信号的指标获取及TR101 290报警；
        4、支持7*24小时自动录像及录像查看下载、实时流媒体查看等功能；
        5、每块板卡支持多套节目监测及录像；
        6、具有指示灯前面显示板卡运行状态；
        7、存储故障容错，支持mSATA接口，配置mSATA固态硬盘，实现本地存储（存储时间7天以上可调、可选），从而充分利用固态硬盘具有的速度快、抗震性好、发热和噪音低、功耗低等优点，进一步简化监测前端设备；
        8、支持Web登录访问配置；
        9、能存储监测指标数据、报警数据及节目录像等；能将监测数据存储一月以上，异态节目记录信息上传到监测平台。`,
        summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
      },
		],
    //软件
		software:[
      {
				id:1,
				name:'中心监管平台',
				img:'/static/img/product/ythglpt.png',
				describe:`中心监管平台，型号: DAVS-MBTV。`,
				summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
			},
			{
				id:1,
				name:'概述',
        img:'',
				describe:`中心监管平台通过专用通信网络向监测前端下达监测任务指令，并接收监测前端上传的监测数据及节目内容等信息，实现运行管理、质量监测、内容监看、EPG监测、安全监测(直转播比对监测、广播电视呼号/台标监测、国歌播放监测等)、监测数据分析处理、异态报警、存储、报表统计、系统管理等功能模块，并提供与监测用户和主管部门的数据接口。系统平台适应性好，针对性强，操作便捷，人机交互界面友好，具有良好的技术架构和技术优势，可定制、可扩展、可集成、跨平台。`,
				summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
			},
			{
				id:2,
				name:'监测平台性能',
				img:'',
				describe:`1、监测平台与监测前端的数据接口符合广电总局通用接口规范；
        2、支持多用户并发访问，并发访问数符合设计需求；
        3、监测前端对监测平台下发的指令响应时间≤3s；监测前端对监测平台下发指令返回响应结果的时间≤5s；
        4、监测平台核心设备或组件具备1+1或以上冗余配置；
        5、监测平台支持用户单位实际业务的定制化需求；
        6、监测平台可以按照地理区域进行定制化，完成数据分发，实现数据共享，向相关单位、机构提供分中心平台系统。`,
				summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
			},
      {
        id:3,
        name:'运行管理功能',
				img:'',
        describe:`1、能向监测前端下达监测任务指令，包括监测的频道、节目及时段；
        2、向监测前端下达的监测任务，具有实时监测、轮循监测和临时监测三种功能；
        （1）实时监测是对单套节目不间断的监测，实时监测任务适用于对重点节目的长期实时监测。
        （2）轮循监测是对多套节目按设定监测时间进行轮流循环监测，轮循监测任务适用于对重要程度较低的节目进行非实时监测。
        （3）临时监测是对临时下达的任务进行监测，适用于在特定的安全播出保障时段内进行设定，在临时监测任务结束后，监测平台及监测前端能直接恢复到此前设定的实时监测或轮循监测业务；
        3、能进行值班管理：具有供值班人员集中处理各前端报警的值班页面，页面提供所有报警日志汇聚功能，并具有实时指标和实时视频查看、历史视频查看、节目录像手动下载和报警处理等功能；
        4、能进行前端设备维护：具有实时查看监测前端总数、正常前端个数、异常前端个数及无连接前端个数等功能；
        5、能对监测前端设备故障和监测前端网络连接中断情况进行自动报警；
        6、能查阅系统日志和设备运行、维护记录；
        7、监测前端与监测平台具有统一的自动校时功能；系统时钟具有一致性，累计误差≤1s/24h。
        8、支持查看设备的基本信息、配置信息、实时指标信息，设备面板接线图，利于设备的远程维护。
        9、支持以机架图的方式展示当前机架设备实际情况，包括机柜和设备的实时状态、指标数据、故障日志、切换日志，掌握整个机房的运行情况。
        10、能对整个监测业务网络及设备的拓扑链路展示，可以查询任意环节网络设备的型号、工作状态和基础信息，支持对网络设备工作状态的监测报警，支持主流厂商网络设备的接入，能够自动识别设备，并且可以手动添加未知设备和编辑网络拓扑。
        11、对网络设备、服务器设备实时运行性能的监控，主要指标包括：设备的CPU利用率、内存利用率、I/O流量、端口丢包率和错包率、端口速率和流量等；支持实时性能监测，实时诊断网络内指定网络设备的监控指标，并将监测的情况以图表的方式显示出来。
        12、对各类服务器、监测主机设备的硬件监控，主要指标包括：CPU利用率、内存利用率、磁盘空间使用率、RAID、温度、风扇转速、电源状态等，也支持对关键进程的CPU/内存占用情况进行监控；支持机房机柜的机架图展示。
        13、对存储设备运行状态的监控，包括: 对磁盘和卷的管理、存储空间使用率等。`,
        summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
      },
      {
        id:4,
        name:'质量监测功能',
				img:'',
        describe:`1、当接收到监测前端的指标越限或视音频异态监测信息时，形成报警记录；
        2、报警记录包含报警原因、发生时间、持续时长及恢复时间等信息。
        3、中心平台可以随时监听监看所属监测前端的任意一套或多套组合的广播电视节目。实现基于TCP协议的音视频流媒体数据实时播放。同时显示各种参数测量曲线图，统计曲线图可打印。
        4、实时报警数据AI智能分析，对采集前端上报的实时报警信息以多维度智能识别分析归类处理，减少数据的误报率，提高整体的监测监管能力和处置安全播出事故的应对能力。`,
        summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
      },
      {
        id:5,
        name:'内容监看功能',
				img:'',
        describe:`1、支持多画面合成及实时监看，支持节目录像多画面比对查看，能设置监看节目和画面布局，并能将异态节目自动调度到指定区域显示；
        2、能查看节目录像、填写监看情况信息和异态原因；
        3、能查询检索节目录像；
        4、支持节目录像剪辑、文件合并、设置入出点及录像文件下载；
        5、宜采用智能识别与人工分析相结合的方式，提高节目内容识别效率与效果。
        6、支持频道轮播，在画面中根据用户设定时间循环轮流播放所选中的节目内容。
        7、选择监测，对未在实际广播电视监测业务范围内，其它任意广播电视节目进行可选、监听监看。
        8、历史播放功能，可回放存储在中心或监测前端中的节目。可按照2 倍速、4倍速、8倍速、16倍速快放，1/2倍速、1/4倍速慢放，可单帧进、单帧退和单帧捕获。播放器具有自动定位功能，并实现“即点即播”功能。`,
        summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
      },
      {
        id:6,
        name:'EPG监测',
				img:'',
        describe:`实现对有线数字电视节目不同频道和时间的EPG信息查看、EPG内容的监听监看。`,
        summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
      },
      {
        id:7,
        name:'直转播比对监测',
				img:'',
        describe:`通过对目标节目和源节目的比对监测，完成节目内容的一致性比对监测，以便发现直播或转播过程中出现的同步转播/漏播、错播/插播等情况。在重要时段对指定的重点节目音视频进行同播比对，如有异常，进行报警提示。`,
        summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
      },
      {
        id:8,
        name:'呼号监测',
				img:'',
        describe:`对采集的调频广播节目实际播出的呼号进行自动监测，在每个整点监测是否播报节目呼号，未播报则报警。`,
        summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
      },
      {
        id:9,
        name:'指定时间播放国歌监测',
				img:'',
        describe:`对监测的广播、电视节目，在指定时间识别、监测是否播放国歌，未播放报警。`,
        summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
      },
      {
        id:10,
        name:'台标监测',
				img:'',
        describe:`对电视节目进行台标识别，生成台标模板特征值，通过台标比对技术，对节目台标进行监测，包括台标丢失、台标异常等报警。`,
        summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
      },
      {
        id:11,
        name:'监测数据分析处理功能',
				img:'',
        describe:`1、能查看监测前端的指标、TS码流标准符合性等监测数据；
        2、能查看TS流的传输流标识、传输节目数、节目名称、PID类型及数量、网络ID以及网络名称等；
        3、能查看指标数据趋势、PSI/SI表格信息解析、EPG信息解析；
        4、能按年、月、日及指定时段统计报警原因、时间和次数等，并能导出报表；
        5、采用大数据、人工智能等技术，对监测数据进行深度分析、态势展示和风险预警。
        6、报警数据分析统计功能。以图形、表格或曲线方式记录、显示、查询数字广播、数字电视实时报警信息、历史报警信息。报警信息包括：节目名称、故障类型、开始时间、恢复时间、故障持续时间。
        7、质量参数分析统计功能。以图形、表格或曲线方式记录、显示、查询数字广播、数字电视指标测量结果，包括射频质量监测结果、码流质量监测结果、音视频监测结果。`,
        summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
      },
      {
        id:12,
        name:'异态报警功能',
				img:'',
        describe:`1、平台能接收监测前端设备上报的异态报警信息，并能对报警信息进行统计分析展示等；
        2、平台具备多种报警方式，包括但不限于：语音或声音提示、画面标题框字体颜色变化、视频画面叠加报警字符。
        3、系统在供电异常终止或宕机再恢复后，能够恢复启动前的异态报警状态。
        4、报警数据具有高优先权，监测前端设备在有其它数据同时上报时，必须优先上报报警数据。
        5、自动依据报警短信发布（已发与未发）、报警开始时间、报警是否进行分类排序。
        6、地图与报警信息同时显示与互相切换，提高实时监测效率。`,
        summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
      },
      {
        id:13,
        name:'存储功能',
				img:'',
        describe:`1、实时、自动存储监测前端上传的监测指标数据；
        2、自动和手动存储节目录像；
        3、支持常用的存储介质及存储文件格式；
        4、支持存储容量剩余空间提醒设置及提醒、报警；
        5、支持监测数据保存一个月以上，异态节目记录信息保存一年以上。`,
        summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
      },
      {
        id:14,
        name:'报表统计功能',
				img:'',
        describe:`支持将安全播出监管、质量监管、内容监管、资源监管统一生成监管月报、季报、年报，并进行报告导出。
        1、通过系统设置自动生成各种报表
        （1）节目频道播出质量(技术指标)统计。系统提供年、季、月、半月、周播出质量情况统计；
        （2）节目频道变动分类统计；
        （3）新增频点频道分类统计；
        （4）自定义统计报表：根据采购人月、季、年数据统计要求，可自定义报表任务,可灵活设置各种选项，生成各类统计报表；
        （5）系统支持3D图形化报表显示等。
        2、支持设置自动报表任务
        （1）在报表任务设置页面，报表任务分为五种：异态发生明细、异态发生次数、异态持续时间；停、劣播、质量指标、频道变动统计等；
        （2）管理人员可以根据实际需要，自定义报表任务,可灵活设置各种选项。
        3、监测数据报表统计打印
        （1）系统可按监测站名称、台名称、节目名称、频点、时间段、开始时间、恢复时间、故障持续时间进行日、周、半月、月、季度、年度报表统计和打印；
        （2）在报表任务查询页面，能够查询到各类型已经设置的报表任务；
        （3）支持报表配置参数的导入、导出。`,
        summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
      },
      {
        id:15,
        name:'可视化展示',
        img:'',
        describe:`以可视化元素和图形、通过数据关系定义实现丰富的可视化效果，提供多种界面供用户选择。
        1、重大事故统计：实时上报重大事故信息统计，通过饼图方式查看已处理和未处理数据分布，可查看监测指挥调度预警发布系统的数据发布情况。
        2、事故统计：实时上报事故报警统计，通过饼图方式查看已处理和未处理数据分布，可查看监测指挥调度预警发布系统的数据发布情况。
        3、节目异态报警统计：实时查看报警数据统计，通过组合柱状图形式统计各监测站点报警分类数据，并且还可按本月、本季、半年、本年等情况统计各站点报警分类数据。
        4、节目异态报警分类：以饼图形式统计不同类型的报警数量，直观查看不同类型的报警数量占比值。
        5、本日节目异态报警：实时推送最新的报警信息，能第一时间了解各站点的报警情况。
        6、设备运行：实时监控监测采集前端设备运行情况（内存、CPU、存储）等实时信息；查看设备数据统计和设备故障统计信息。`,
        summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
      },
		],
    nrjg:[
      {
				id:1,
				name:'广播电视节目内容监测监管系统',
        img:'/static/img/product/nrjg.png',
				describe:`广播电视节目内容监测监管系统，型号: DAVS-PCM。`,
				summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
			},
			{
				id:1,
				name:'概述',
        img:'',
				describe:`采用视音频智能处理技术和引擎，实现对调频广播、有线数字电视节目内容监管。具有广播频率和电视频道实时收听收看、录音录像文件播放、节目节选和取证、广播电视节目评议、语音识别分析等功能模块。`,
				summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
			},
			{
				id:2,
				name:'广播电视实时收听收看',
				img:'',
				describe:`1、对要监测的广播、电视节目进行实时监听、监看，播放过程中，音视频流畅、无卡顿、视频无马赛克，并显示叠加的OSD信息，可灵活自由切换所有频道/频率。
        2、对监测的电视节目实现实时多画面监看，多画面的画面数量、监看节目等可以由用户进行选择切换并能保存、调用选定通道方案。
        3、电视实时对比监看：重要活动转播时，选定一个电视频道主信源和一个电视频道待比对信源，进行实时内容比对，及时发现字幕等其他内容的违规现象。
        4、广播实时对比监听：重要活动转播时，选定一个广播频率主信源和一个广播频率待比对信源，进行实时比对，及时发现其他内容的违规现象。`,
				summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
			},
      {
          id:3,
          name:'录音录像播放',
          img:'',
          describe:`1、对要监测的广播、电视节目录音录像文件进行播放，可由用户有选择的对信号类型、前端站点、节目名称、播出日期、播出时间、播放速度等进行自由设定。
          2、通过点击频道EPG节目单自动定位播放。
          3、实现录音录像保存时段内历史任意时段的录音录像查看功能。
          4、可按照2 倍速、4倍速、8倍速、16倍速快放，1/2倍速、1/4倍速慢放，可单帧进、单帧退和单帧捕获。具有自动定位功能，并实现“即点即播”功能，支持节目搜索功能。`,
          summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
      },
      {
          id:4,
          name:'节目节选和取证',
          img:'',
          describe:`系统具备广播、电视音视频节目节选和取证功能，对要监测的广播、电视节目进行截取保存到中心的存储服务器，对需要做语音识别节目自动下发任务完成语音识别。系统结合EPG信息等实现新闻和专题栏目识别功能。系统支持按照播出日期和时间等规则配置栏目名称和类型，并在此节目录音录像基础上派发任务。
          节目取证，对播放的音视频按照用户要求进行截屏、录音录像下载、分类录制取证(文本、图片、录音和录像)，可对取证文件进行查看和编辑操作。`,
          summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
      },
      {
        id:5,
        name:'广播电视节目评议',
				img:'',
        describe:`1、系统对监测的广播、电视节目，在播放时，提供文字输入界面，由用户对节目进行评议，支持评议内容的编辑、保存、提交等。
        2、历史评议信息检索
        （1）依据频道名称、节目名称、评议日期等，查询历史评议信息列表，包括：频道名称 、节目日期 、节目名称 、评议时间段 、评议内容等。
        （2）支持播放、上传、删除等操作。支持展示语音文字翻译、关键字、检索关键字等操作。
        3、录像播放，可按照2 倍速、4倍速、8倍速、16倍速快放，1/2倍速、1/4倍速慢放，可单帧进、单帧退和单帧捕获。
        4、支持展示语音文字翻译、关键字、检索关键字等操作。
        5、依据统计时间、评议专家查询稿件统计，包括：评议时长统计、任务数统计、稿件数量统计、评议字数统计，以饼状图形式展示。`,
        summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
      },
      {
        id:6,
        name:'语音识别分析',
				img:'',
        describe:`语音识别分析采用科大讯飞语音转写引擎，单套语音转文本引警单日可以处理 240小时左右的电视节目或160小时左右的广播，电视一般转换（新闻+专栏+广告+其他节目），一套节目的量大概是在4-6小时左右，一套广播平均一天一般按12个小时左右。
        对监测的广播、电视节目进行语音识别分析，并将语音转换为文字内容，并同步显示，文字内容可以快速检索，识别的节目数量≥80套。智能语音识别引擎在无背景音干扰下的标准普通话，语音识别准确率≥95%，识别效率≥15倍速。`,
        summary:`1.19英寸标准工业级机…\n2.支持标准CPCI设备\n3.支持热插拔\n……\n`
      },
		],
	},

	//地图数据
	chinaGeoCoordMap:{
		'黑龙江': [127.9688, 45.368],
		'内蒙古': [110.3467, 41.4899],
		"吉林": [125.8154, 44.2584],
		'北京市': [116.4551, 40.2539],
		"辽宁": [123.1238, 42.1216],
		"河北": [114.4995, 38.1006],
		"天津": [117.4219, 39.4189],
		"山西": [112.3352, 37.9413],
		"陕西": [109.1162, 34.2004],
		"甘肃": [103.5901, 36.3043],
		"宁夏": [106.3586, 38.1775],
		"青海": [101.4038, 36.8207],
		"新疆": [87.9236, 43.5883],
		"西藏": [91.11, 29.97],
		"四川": [103.9526, 30.7617],
		"重庆": [108.384366, 30.439702],
		"山东": [117.1582, 36.8701],
		"河南": [113.4668, 34.6234],
		"江苏": [118.8062, 31.9208],
		"安徽": [117.29, 32.0581],
		"湖北": [114.3896, 30.6628],
		"浙江": [119.5313, 29.8773],
		"福建": [119.4543, 25.9222],
		"江西": [116.0046, 28.6633],
		"湖南": [113.0823, 28.2568],
		"贵州": [106.6992, 26.7682],
		"云南": [102.9199, 25.4663],
		"广东": [113.12244, 23.009505],
		"广西": [108.479, 23.1152],
		"海南": [110.3893, 19.8516],
		'上海': [121.4648, 31.2891]
	},
	//有项目的省份（要新增直接放开对应注释即可）
	chinaDatas: [
		// [{
		// 	name: '黑龙江',
		// 	value: 0
		// }],
		[{
			name: '上海',
			value: 0
		}],
		[{
			name: '内蒙古',
			value: 0
		}],
		// [{
		// 	name: '吉林',
		// 	value: 0
		// }],
		// [{
		// 	name: '辽宁',
		// 	value: 0
		// }],
		// [{
		// 	name: '河北',
		// 	value: 0
		// }],
		// [{
		// 	name: '天津',
		// 	value: 0
		// }],
		[{
			name: '山西',
			value: 0
		}],
		[{
			name: '陕西',
			value: 0
		}],
		// [{
		// 	name: '甘肃',
		// 	value: 0
		// }],
		// [{
		// 	name: '宁夏',
		// 	value: 0
		// }],
		// [{
		// 	name: '青海',
		// 	value: 0
		// }],
		// [{
		// 	name: '新疆',
		// 	value: 0
		// }],
		[{
			name: '西藏',
			value: 0
		}],
		// [{
		// 	name: '四川',
		// 	value: 0
		// }],
		// [{
		// 	name: '重庆',
		// 	value: 0
		// }],
		[{
			name: '山东',
			value: 0
		}],
		// [{
		// 	name: '河南',
		// 	value: 0
		// }],
		[{
			name: '江苏',
			value: 0
		}],
		[{
			name: '安徽',
			value: 0
		}],
		[{
			name: '湖北',
			value: 0
		}],
		// [{
		// 	name: '浙江',
		// 	value: 0
		// }],
		[{
			name: '福建',
			value: 0
		}],
		// [{
		// 	name: '江西',
		// 	value: 0
		// }],
		// [{
		// 	name: '湖南',
		// 	value: 0
		// }],
		[{
			name: '贵州',
			value: 0
		}],
		[{
			name: '广西',
			value: 0
		}],
		[{
			name: '海南',
			value: 0
		}],
		// [{
		// 	name: '北京市',
		// 	value: 1
		// }]
	],
})

const getters = {
	//获取搜索组件状态
	getSearchStatus:state=>state.isShowSearch,
	//获取首页播放按钮显示状态
	getVideoBtnShowStatus:state=>state.isShowVideoBtn,
	//获取头部可隐藏状态
	getHeaderHideAbleStatus:state=>state.headerHideAble,
	//获取热门搜索数据
	getSearchHot:state=>state.searchHot,

	//获取产品列表
	getProductList:state=>state.productList,
	//获取产品
	getProducts:(state)=>{
		return [...state.productList.software,...state.productList.hardware,...state.productList.iptv,...state.productList.szdsqd,...state.productList.nrjg];
	},

	//获取地图数据
	getChinaGeoCoordMap:state=>state.chinaGeoCoordMap,
	//获取有项目的省份信息
	getChinaDatas:state=>state.chinaDatas,

	//获取软件列表
	getSoftwareList:state=>state.productList.software,
	//获取硬件列表
	getHardwareList:state=>state.productList.hardware,
  //获取IPTV列表
	getIPTVList:state=>state.productList.iptv,
  //数字电视前端
	getSzdsqdList:state=>state.productList.szdsqd,
    //nrjg
	getNrjgList:state=>state.productList.nrjg,
}

const mutations = {
	//设置搜索组件状态
	setSearchStatus(state,status){
		// console.log('status', status);
		state.isShowSearch = status;
	},
	//设置首页播放按钮显示状态
	setVideoBtnShowStatus(state,status){
		state.isShowVideoBtn = status;
	},
	//设置首页播放按钮显示状态
	setHeaderHideAbleStatus(state,status){
		state.headerHideAble = status;
	}
}

const actions = {
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/common.js